var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('dataset-crud',{attrs:{"title":"Gestion des Bin","dataset":_vm.$store.state.bin_mapping}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }